<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgemetn">
<h1>Acknowledgement</h1>
<p style="text-indent: 00em;">Archie Spinner</p><br/>
<p style="text-indent: 00em;">Consultant Psychiatrist Dr Rosaria Forlano, Alfred Hospital</p><br/>
<p style="text-indent: 00em;">Consultant Occupational Therapist, Shane McSweeney</p><br/>
<p style="text-indent: 00em;">Artist, Matthew Harman Parsons</p><br/>
<p style="text-indent: 00em;">Brenda Seckold and Mark Seckold</p><br/>
<p style="text-indent: 00em;">Graeme Fallet and Angela Fallet</p><br/>
<p style="text-indent: 00em;">Writer’s Studio, Helen Shorrocks and Rochelle Bright</p><br/>
<p style="text-indent: 00em;">Barrister, Darren Mort</p><br/>
<p style="text-indent: 00em;">Mary Kourelis and Mark Henderson (Engagement Hub)</p><br/>
<p style="text-indent: 00em;">Helen Maxwell-Wright</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3423bc63